import { render, staticRenderFns } from "./ErrorBox.vue?vue&type=template&id=ff14c18e&scoped=true"
var script = {}
import style0 from "./ErrorBox.vue?vue&type=style&index=0&id=ff14c18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff14c18e",
  null
  
)

export default component.exports